import { RootState } from "@core/interfaces";

export const getUserInfor = () => {
  return (state: RootState) => state.user;
};
